import { Component, HostBinding, Input } from '@angular/core';
@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css'],
})
export class CardComponent {
  @Input() color: string = '';
  @Input() img: string = '';
  @Input() title: string = '';
  @Input() icon: boolean = false;
  @Input() description!: string | string[];
  @HostBinding('class') cardClasses = 'col-12 col-sm-6 col-md-4';
  getDescriptionAsArray(): string[] {
    return typeof this.description === 'string'
      ? [this.description]
      : this.description;
  }
}
